import { graphql } from '@/generated/gql'

export const GET_CONTENT_ITEM_COMMENTS =
    graphql(`query CommentsByContentId($input: ViewCommentModelsInput!, $after: String, $first: Int, $last: Int, $before: String) {
  commentsByContentId(input: $input, after: $after, first: $first, last: $last, before: $before) {
    pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
      nodes{
        id
        contentId
        textBody
        createdAt
        isUpdated
        commentSource
        user {
          createdDate
          user {
            id
            displayName
            fullName
            firstName
            lastName
            email
            imageUrl
            role
            isConfirmedEmail
            meetplaceId
            isConfirmedEmail
            isMeetplaceInvitationInvalid
            isMeetplaceInvitationExpired
            jobTitle
            userStatus
          }
        }
        reactions{
          reactionSymbol
          reactors{
            userId
            user {
              id
              displayName
            }
          }
        }
      }
  }
}`)
